import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/afya.jpg";

export default function SplashScreen() {
  const containerRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {

    const timeoutId = setTimeout(() => {
      gsap.to(containerRef.current, {
        opacity: 0,
        duration: 0.8,
        onComplete: () => {
          navigate("/home");
        },
      });
    }, 4000);

    return () => clearTimeout(timeoutId);
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-primary text-white transition-all duration-1000 ease-in-out">
          <img
            src={logo}
            alt="Afya ustawi foundation Logo"
            className="w-36 rounded-full h-36 mb-6 animate-bounce drop-shadow-xl"
          />
          <h1 className="text-3xl font-bold tracking-wide">Afya Ustawi Foundation</h1>
          <p className="mt-3 text-sm opacity-80 animate-pulse"></p>
          <div className="w-24 h-1 mt-8 bg-white rounded-full animate-ping" />
        </div>
  );
}
